/* ==========================================================================
   Theme Toggle — Dark/Light Mode
   That's Coffee Theme v2 (Barista Design System)
   ========================================================================== */

(function () {
  const STORAGE_KEY = 'tc-theme-preference';

  function getDefaultMode() {
    const el = document.querySelector('[data-default-theme-mode]');
    return el ? el.getAttribute('data-default-theme-mode') : 'light';
  }

  function getPreference() {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) return stored;

    const defaultMode = getDefaultMode();
    if (defaultMode === 'system') {
      return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }
    return defaultMode;
  }

  function setTheme(theme) {
    document.documentElement.setAttribute('data-theme', theme);
    document.body.setAttribute('data-theme', theme);
    localStorage.setItem(STORAGE_KEY, theme);

    document.querySelectorAll('.tc-theme-toggle').forEach(function (btn) {
      if (theme === 'dark') {
        btn.classList.add('is-dark');
      } else {
        btn.classList.remove('is-dark');
      }
      btn.setAttribute('aria-label',
        theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'
      );
    });
  }

  // Apply immediately to prevent flash of wrong theme
  var preference = getPreference();
  document.documentElement.setAttribute('data-theme', preference);

  document.addEventListener('DOMContentLoaded', function () {
    // Re-apply after DOM is ready (ensures body gets the attribute too)
    setTheme(getPreference());

    // Bind click handlers
    document.querySelectorAll('.tc-theme-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var current = document.documentElement.getAttribute('data-theme');
        setTheme(current === 'dark' ? 'light' : 'dark');
      });
    });

    // Listen for system preference changes
    if (getDefaultMode() === 'system') {
      window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function (e) {
        if (!localStorage.getItem(STORAGE_KEY)) {
          setTheme(e.matches ? 'dark' : 'light');
        }
      });
    }
  });
})();
